export default "__VITE_ASSET__DcmB3XIr__"